
import { useState } from "react";

type InventoryActionItem =
  | { id: string; quantity: number }
  | { id: string; action: 'remove' }
  | { oldId: string; newId: string; action: 'replace' };

export interface LastAction {
  type: 'inventory' | 'kit';
  item: InventoryActionItem;
  undoable: boolean;
}

export function useRentalInventory() {
  const [lastAction, setLastAction] = useState<LastAction | null>(null);

  const handleInventoryItemChange = (id: string, quantity: number) => {
    console.log('[useRentalInventory] Inventory item changed:', id, 'quantity:', quantity);
    
    // Устанавливаем последнее действие для возможности отмены
    setLastAction({
      type: 'inventory',
      item: { id, quantity },
      undoable: true
    });
  };

  const handleInventoryItemRemove = (itemId: string) => {
    console.log('[useRentalInventory] Removing inventory item:', itemId);
    
    // Сохраняем действие удаления для отмены
    setLastAction({
      type: 'inventory', 
      item: { id: itemId, action: 'remove' },
      undoable: true
    });
  };

  const handleInventoryItemReplace = (oldItemId: string, newItemId: string) => {
    console.log('[useRentalInventory] Replacing inventory item:', oldItemId, 'with', newItemId);
    
    setLastAction({
      type: 'inventory',
      item: { oldId: oldItemId, newId: newItemId, action: 'replace' },
      undoable: true
    });
  };

  const handleUndoLastAction = () => {
    console.log('[useRentalInventory] Undoing last action:', lastAction);
    setLastAction(null);
  };

  return {
    lastAction,
    handleInventoryItemChange,
    handleInventoryItemRemove,
    handleInventoryItemReplace,
    handleUndoLastAction
  };
}
